<template>
  <div class="proof-card grid-item">
    <div class="grid-item-container">
      <v-row dense>
        <v-col cols="12" class="pa-4">
          <h5 class="color light-gray text-right">{{ proof.proof_date | prettyDate }}</h5>
        </v-col>
      </v-row>

      <Facebook
        v-if="proof.fb_checkin || (proof.proof_type === 'FACEBOOK_POST' && proof.message_content)"
        :proof-type="proof.proof_type"
        :image-url="proof.img_url"
        :fb-checkin="proof.fb_checkin"
        :influencer="proof.influencer"
        :message-content="proof.message_content"
      />

      <ScreenShotPost v-else :img-url="proof.img_url" :message-content="proof.message_content" />

      <v-row dense class="proof-card-footer">
        <v-col cols="12" class="pa-4 text-center">
          <h5 class="color light-gray text-uppercase opacity-50">
            <v-img :src="getProofIcon" aspect-ratio="1" height="16" width="16" class="p-0 mr-1 d-inline-flex" style="filter: brightness(0.5)" />
            {{ getProofTitle }}
          </h5>
          <div>
            <h6 v-if="proof.date_redeemed" class="color light-gray caption font-weight-light mt-2">Redeemed {{ proof.date_redeemed | monthDayYearDate }}</h6>
            <template v-if="proof.client_feedback_eligible">
              <v-btn
                v-if="!proof.client_feedback_app_user_id"
                fab
                x-small
                elevation="3"
                color="#539FDB"
                class="client-feedback-button"
                @click="showProofFeedbackModal = true"
              >
                <v-icon color="white">mdi-chat-plus</v-icon>
              </v-btn>
              <img
                v-else
                width="30"
                height="30"
                class="client-feedback-button"
                title="Thanks for the feedback!"
                :src="require('@/assets/svg/proof-feedback-success.svg')"
              />
            </template>
          </div>
        </v-col>
      </v-row>
    </div>

    <ProofFeedbackModal v-if="showProofFeedbackModal" :proof="proof" @proof-feedback-modal-close="showProofFeedbackModal = false" />
  </div>
</template>

<script>
import taskTypes from '../../models/taskType'

export default {
  name: 'ProofCard',

  components: {
    Facebook: () => import('./ProofCardContent/Facebook.vue'),
    ScreenShotPost: () => import('./ProofCardContent/ScreenShotPost.vue'),
    ProofFeedbackModal: () => import('./ProofFeedbackModal.vue'),
  },

  props: {
    proof: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    showProofFeedbackModal: false,
  }),

  computed: {
    getProofTitle() {
      if (!this.proof.proof_type) return 'Sway Offer'

      const proofType = taskTypes[this.proof.proof_type]
      return proofType ? proofType.title : ''
    },
    getProofIcon() {
      if (!this.proof.proof_type) return require('@/assets/svg/localfluence.svg')

      const proofType = taskTypes[this.proof.proof_type]
      return proofType ? proofType.icon : ''
    },
  },
}
</script>

<style scoped>
.proof-card {
  border: solid 1px #eee;
  border-radius: 10px;
}

.proof-card-footer {
  position: relative;
}

.client-feedback-button {
  right: 20px;
  bottom: 15px;
  float: right;
  position: absolute;
}
</style>
